'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CloseIcon = require('../../../icons/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ours.
var ModalHeader = function ModalHeader(props) {
  var qaId = 'modal-header-close-icon';
  return _react2.default.createElement(
    'h1',
    { className: _styles2.default.modal__header },
    _react2.default.createElement(
      'span',
      { className: _styles2.default.header__text },
      props.title
    ),
    _react2.default.createElement(
      'span',
      {
        className: _styles2.default.header__dismiss,
        onClick: props.onClose,
        'data-qa': qaId
      },
      _react2.default.createElement(_CloseIcon2.default, { size: 'medium' })
    )
  );
}; // Theirs.


ModalHeader.propTypes = {
  title: _react.PropTypes.string.isRequired,
  onClose: _react.PropTypes.func
};

exports.default = ModalHeader;